"use client";
import React, { useState } from "react";
import { FmButton, FmDrawer } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";
import stl from "./answerItem.module.scss";
import { loginOrNotNoJump } from "@/lib/commonService";
import { openUploadStore, signInModal } from "@/store";
import { gaLoadedPromise, gaWriteReviewClick } from "@/src/utils/gtagEvents";
import dynamic from "next/dynamic";
import classnames from "classnames";
import AnswerList from "./AnswerList";
import variable from "@/src/styles/variables.module.scss";
import SelectContainer from "../../SelectContainer";
import ColorComfirmBtn from "../../ColorComfirmBtn";
const WriteReviewForm = dynamic(
    () => import("@/src/productDetails/WriteReviewForm"),
);
export interface IProductAnserClientProps {
    askNum: number;
    id: number;
    userInfo: any;
}
// 内部接口
interface IInsertProps {
    isPackage: boolean;
}
const ProductAnswerClient: React.FC<
    React.PropsWithChildren<IProductAnserClientProps & IInsertProps>
> = (props) => {
    const { askNum, id, isPackage } = props;
    const { t } = useTranslation(["common", "productDetail", "review"]);
    const [openModal] = signInModal.useSignInModalStore((state) => [
        state.openModal,
    ]);

    const [open, openUpload] = openUploadStore.useOpenUploadStore((state) => [
        state.open,
        state.openUpload,
    ]);

    const checkCommentAuth = () => {
        openUpload(true);
        //GA评价
        gaLoadedPromise()
            .then((res) => {
                gaWriteReviewClick();
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const [isShowList, setIsShowList] = useState(false);
    const toggerShowList = () => {
        setIsShowList((prev) => !prev);
    };

    const openUploadTransfer = () => {
        if (!loginOrNotNoJump()) {
            openModal();
        } else {
            checkCommentAuth();
        }
    };

    return (
        <>
            {props.children}
            {askNum > 2 && (
                <FmButton
                    size="medium"
                    onClick={toggerShowList}
                    className={stl["read-all-qas"]}
                >
                    {t(`review:READ_ALL_QAS`)}
                </FmButton>
            )}
            <FmButton
                onClick={openUploadTransfer}
                size="medium"
                style={{ margin: "0.2rem auto", width: "max-content" }}
                variant="text"
                iconLeft
                buttonColor={variable.main}
                icon={"icon--ask"}
                contentClassName={stl["ask-to-open-writeform"]}
                iconClassName={stl["icon--ask-to-open-writeform"]}
            >
                {t("common:btn.AskQuestion")}
            </FmButton>
            <FmDrawer
                closeable={true}
                open={isShowList}
                onClose={toggerShowList}
                closeablePosition="right"
                headerChildren={
                    <div className={stl["header-show-list"]}>
                        {t("productDetail:Q&As")}({askNum})
                    </div>
                }
                anchor="bottom"
                fullHeight
                childrenClassName={classnames(
                    stl["drawer-children"],
                    "color-select-drawer",
                )}
            >
                <AnswerList id={id} userInfo={props.userInfo} />
                <div className={stl["bottom-line"]}>
                    <div
                        className={classnames(
                            "default_layout",
                            stl["bottom-button-container"],
                        )}
                        style={{ justifyContent: "space-between" }}
                    >
                        <FmButton
                            onClick={openUploadTransfer}
                            size="medium"
                            variant="outlined"
                            buttonColor="#000"
                        >
                            {t("common:btn.AskQuestion")}
                        </FmButton>
                        {isPackage ? (
                            <SelectContainer width="3rem" />
                        ) : (
                            <ColorComfirmBtn />
                        )}
                    </div>
                </div>
            </FmDrawer>
            {open && <WriteReviewForm productId={id} type={1} />}
        </>
    );
};

export default ProductAnswerClient;
